/** @format */
import React from "react";

export default ({ title, subtext }) => (
  <div className="OnboardingHeader">
    <h4>{title}</h4>
    <div className="OnboardingHeader-subtext">{subtext}</div>
  </div>
);
